import topHundredSnippets from "./data/top-hundred-snippets.js";
import snippets from "./data/snippets.js";
import { applySnippet, extendOverUnpairedClosingBrace } from "./apply.js";
/**
 * Completions based on bundled snippets
 */
export function buildSnippetCompletions(completions) {
    for (const item of topHundredSnippets) {
        completions.commands.push({
            type: item.meta,
            label: item.caption,
            boost: item.score,
            apply: item.snippet === item.caption ? undefined : applySnippet(item.snippet),
            extend: extendOverUnpairedClosingBrace,
        });
    }
    for (const item of snippets) {
        completions.commands.push({
            type: item.type,
            label: item.label,
            apply: applySnippet(item.snippet),
            extend: extendOverUnpairedClosingBrace,
        });
    }
}
